import React, { Fragment } from 'react';
import { Card, Col, Form, Input, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';

export default (props) => {

	const { getFieldDecorator } = props.form;

	return (
		<Fragment>
			<Card title="Thông tin chung">

				<Row gutter={12}>
					<Col span={12}>
						<Form.Item
							label={'Tên khách hàng'}
							required>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: 'Vui lòng nhập tên khách hàng' }]
							})(
								<Input placeholder="Nhập tên khách hàng" allowClear />
							)}
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label={'Mã khách hàng'}
							required>
							{getFieldDecorator('customerCode')(
								<Input allowClear disabled />
							)}
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label={'Số điện thoại'}>
							{getFieldDecorator('phone', {
								rules: [
									{
										pattern: /^0\d{9}$/,
										message: 'Số điện thoại không hợp lệ!'
									}
								]
							})(
								<Input maxLength={20} placeholder={'Nhập số điện thoại'} allowClear />
							)}
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label={'Email'}>
							{getFieldDecorator('email', {
								rules: [
									{
										type: 'email',
										message: 'Email không hợp lệ!'
									}
								]
							})(
								<Input maxLength={255} placeholder={'Nhập email'} allowClear />
							)}
						</Form.Item>
					</Col>
					{/*<Col span={12}>*/}
					{/*	<Form.Item label={'Khu vực'}>*/}
					{/*		{getFieldDecorator('province', {})(*/}
					{/*			<Select placeholder={'Chọn khu vực'} allowClear>*/}
					{/*				/!*<Option>Pending...</Option>*!/*/}
					{/*			</Select>*/}
					{/*		)}*/}
					{/*	</Form.Item>*/}
					{/*</Col>*/}
					{/*<Col span={12}>*/}
					{/*	<Form.Item label={'Xã phường'}>*/}
					{/*		{getFieldDecorator('ward', {})(*/}
					{/*			<Select placeholder={'Chọn xã phường'} allowClear>*/}
					{/*				/!*<Option>Pending...</Option>*!/*/}
					{/*			</Select>*/}
					{/*		)}*/}
					{/*	</Form.Item>*/}
					{/*</Col>*/}
					<Col span={24}>
						<Form.Item label={'Địa chỉ cụ thể'}>
							{getFieldDecorator('addressText', {})(
								<TextArea maxLength={255} placeholder={'Nhập địa chỉ cụ thể'} allowClear />
							)}
						</Form.Item>
					</Col>
				</Row>
			</Card>
		</Fragment>
	);
};
